var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:[_vm.isNoData ? 'jd-no-data-img' : '', 'normal-img'],style:(_vm.imageStyle),attrs:{"src":_vm.fullSrc,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }